import React, { useState, useEffect } from 'react'
import { Card, Row, Col, Statistic, Select, Empty } from 'antd'
import { CommentOutlined, MessageOutlined, CheckCircleOutlined, RobotOutlined, ClockCircleOutlined } from '@ant-design/icons'
import api from '../../api'

function DashboardPanel() {
  const [summary, setSummary] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    (async () => {
      setLoading(true)
      const res = await api.getDashboardSummary()
      setSummary(res)
      setLoading(false)
    })()
  }, [])

  if (!summary && !loading) return <Empty description="暂无互动数据" />

  const stats = summary || {
    totalComments: 0, totalMessages: 0, repliedComments: 0, repliedMessages: 0,
    autoReplyCount: 0, autoReplySuccessRate: 0, avgResponseTime: 0,
    platformStats: [], topKeywords: []
  }

  return (
    <div>
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}><Card><Statistic title="评论总数" value={stats.totalComments} prefix={<CommentOutlined />} loading={loading} /></Card></Col>
        <Col span={6}><Card><Statistic title="私信总数" value={stats.totalMessages} prefix={<MessageOutlined />} loading={loading} /></Card></Col>
        <Col span={6}><Card><Statistic title="已回复" value={(stats.repliedComments || 0) + (stats.repliedMessages || 0)} prefix={<CheckCircleOutlined />} loading={loading} /></Card></Col>
        <Col span={6}><Card><Statistic title="自动回复次数" value={stats.autoReplyCount} prefix={<RobotOutlined />} loading={loading} /></Card></Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}><Card><Statistic title="自动回复成功率" value={stats.autoReplySuccessRate} suffix="%" precision={1} loading={loading} /></Card></Col>
        <Col span={6}><Card><Statistic title="平均响应时间" value={stats.avgResponseTime} suffix="秒" precision={0} prefix={<ClockCircleOutlined />} loading={loading} /></Card></Col>
      </Row>
      <Card title="平台互动分布">
        {stats.platformStats && stats.platformStats.length > 0 ? (
          stats.platformStats.map(p => (
            <div key={p.platform} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
              <span>{p.name}</span>
              <span>评论 {p.comments} | 私信 {p.messages} | 已回 {p.replied}</span>
            </div>
          ))
        ) : <Empty description="暂无平台数据" />}
      </Card>
    </div>
  )
}

export default DashboardPanel
